import React, { useState, useEffect, useRef } from "react";
import {
  Segment,
  Header,
  Dropdown,
  Input,
  Label,
  Grid,
  Button,
  Breadcrumb,
  Icon,
  Loader,
  Dimmer,
  Image,
} from "semantic-ui-react";
import AdminContent from "../Components/AdminContent";
import "../Css/CreateArticle.css";
import { currentLang } from "../utils/lang";
import { Editor } from "@tinymce/tinymce-react";
import { DateInput } from "semantic-ui-calendar-react";
import {
  getArticleCategorys,
  getPortfolioAllCategorys,
  uploadToArticles,
  getArticles,
  getCategorys,
  getArticleByid,
  getArticleTextByid,
} from "../utils/articleFuncton";
import { useHistory, useParams } from "react-router";
import { auth } from "../utils/firebase";
import AvatarEditor from "../Components/AvatarEditor";

window.onbeforeunload = function () {
  return "Are you sure you want to leave?";
};
window.onload = function () {};

function CreateArticle({ editId }) {
  var useDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [isBusy, setIsBusy] = useState(false);

  const titleRef = useRef(null);
  const textRef = useRef(null);

  const [text, setText] = useState({
    zh: "",
    en: "",
  });
  const [title, setTitle] = useState({
    zh: "",
    en: "",
  });

  const langOptions = [
    { key: "zh_TW", value: "zh", flag: "tw", text: "中文(台灣)" },
    { key: "en", value: "en", flag: "us", text: "英文" },
  ];

  const [editLang, seteditLang] = useState(langOptions[0]);

  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState([]);

  const [subCateOpts, setsubCateOpts] = useState([]);

  //網址參數: 類別/副類別
  //const { genre, cate, subcate } = useParams();
  const [currentSubCate, setcurrentSubCate] = useState();
  const [date, setDate] = useState(
    new Date().toISOString().slice(0, 10).toString()
  );

  const [thumbnail, setThumbnail] = useState({
    src: "https://react.semantic-ui.com/images/wireframe/image.png",
    width: 0,
    height: 0,
  });
  const [openAvatarEditor, setOpenAvatarEditor] = useState(false);

  const [isUploading, setIsUploading] = useState(false);

  const handleAddTag = (key) => {
    if (key.code == "Enter") {
      var tempTags = tags;
      tempTags.push(tagInput);
      setTags(tempTags);
      setTagInput("");
    }
  };

  //URL 效果
  const sections = [{ key: "Home", content: "Home", link: true, href: "/" }];

  //刪除tag
  function handleDeleteTag(index) {
    const tempTags = tags.filter((tag, i) => index != i);
    setTags(tempTags);
  }
  //上傳
  function handleSubmit() {
    //開始上傳
    setIsUploading(true);
    console.log(title);
    console.log(text);
    console.log(tags);
    
    
    uploadToArticles({
      editId: editId,
      catid: currentSubCate,
      thumbnail: thumbnail,
      title: title,
      tag: tags,
      publishDate: date,
      text: text,
    })
      .then((e) => {
        window.location.replace("/");
        console.log(e);
      })
      .catch((e) => {
        setIsUploading(false);
        console.log(e);
      });
  }
  //取得分類清單
  useEffect(() => {
    getCategorys().then((data) => {
      console.log(data);
      const _cates = [{}];
      data.docs.forEach((doc) => {
        _cates.push({
          key: doc.id,
          value: doc.id,
          text: doc.data()?.catName[currentLang],
        });
      });
      setsubCateOpts(_cates);
    });
  }, []);

  useEffect(() => {
    if (!editId) return;
    setIsBusy(true);
    // [編輯模式] 取得文章資料
    console.log("loading data:");
    console.log(editId);
    getArticleByid(editId).then((res) => {
      var _data = res.data();
      //內文
      getArticleTextByid(editId).then((_text) => {
        var _textData = _text.data();
        setText(_textData ? _textData.text : "");
      });
      console.log(res);

      //標題
      //setText(_data?.data);
      setTitle(_data?.title);
      console.log(titleRef);

      //tag
      setTags(_data?.tag);
      //預覽圖
      setThumbnail(_data?.thumbnail);
      //主題
      setcurrentSubCate(_data?.catid);
      //時間
      setDate(_data?.publishDate);

      setIsBusy(false);
    });
  }, [editId]);

  //切換語言時，保存目前資料
  function updateLang(prev, prop) {
    /*
    var _t = Object.assign({}, title);
    _t[prev.value] = titleRef.current.value;
    setTitle(_t);*/

    //紀錄內文
    /*
    var _c = Object.assign({}, text);
    _c[prev.value] = textRef.current.getContent();
    setText(_c);*/

    //切換對應語言之內容
    titleRef.current.value = title[prop.value];
    textRef.current.setContent(text[prop.value]);

    return prop;
  }

  if (isBusy) return <></>;
  else
    return (
      <>
        <AdminContent>
          <Dimmer.Dimmable as="div" dimmed={isUploading}>
            <Dimmer active={isUploading} inverted>
              <Loader>Loading</Loader>
            </Dimmer>
            <div className="ca__headNav">
              <Button
                className="ui button ca__headNavButton"
                onClick={(e) => {
                  window.onbeforeunload = null;
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <Icon name="upload" className="ui icon" color="black"></Icon>
                發佈
              </Button>
            </div>
            <div className="ca__root">
              {/* 標題 */}
              <Header>
                <i class="edit outline icon"></i>
                <Header.Content>文章</Header.Content>
                <Header.Subheader>
                  {/* 網址導覽：類型 */}
                  <Breadcrumb icon="right angle" sections={sections} />
                </Header.Subheader>
              </Header>

              <form>
                {/* 語系選擇 */}
                <div className="ca__dropdownContainer">
                  <Dropdown
                    placeholder="選擇語系"
                    search
                    selection
                    value={editLang.value}
                    onChange={(e, data) => {
                      //seteditLang(data);
                      seteditLang(function (prev, props) {
                        console.log(prev);
                        updateLang(prev, data);
                        return data;
                      });
                    }}
                    options={langOptions}
                  ></Dropdown>
                </div>

                {/* 選擇分類 */}
                <Grid.Column className="ca__dropdownContainer">
                  <Dropdown
                    placeholder="主題"
                    search
                    selection
                    value={currentSubCate}
                    onChange={(e, data) => {
                      window.history.replaceState(null, "", data.value);
                      setcurrentSubCate(data.value);
                      console.log(data);
                    }}
                    options={subCateOpts}
                  ></Dropdown>
                </Grid.Column>

                {/* 發布時間 */}
                <DateInput
                  className="ca__dropdownContainer"
                  name="date"
                  placeholder="Release Date"
                  value={date}
                  dateFormat="YYYY-MM-DD"
                  iconPosition="left"
                  onChange={(e, { name, value }) => {
                    setDate(value);
                  }}
                />
                {/* 縮圖 */}
                <div className="createArticle__thumb-upload-container">
                  <p>縮圖</p>
                  <button
                    className="createArticle__thumb-container"
                    tabindex="-1"
                    onFocus={() => setOpenAvatarEditor(true)}
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    {console.log(thumbnail)}
                    <img
                      src={thumbnail?.src}
                      className="createArticle__image"
                      style={{
                        width: thumbnail?.scale,
                        height: thumbnail?.scale,
                        top: thumbnail?.top,
                        left: thumbnail?.left,
                      }}
                    ></img>
                  </button>
                </div>
                <div style={{ display: openAvatarEditor ? "block" : "none" }}>
                  <AvatarEditor
                    img={thumbnail?.src}
                    scale={thumbnail?.scale}
                    width={thumbnail?.scale}
                    height={thumbnail?.scale}
                    top={thumbnail?.top}
                    left={thumbnail?.left}
                    onsubmit={(e) => {
                      setThumbnail(e);
                      setOpenAvatarEditor(false);
                    }}
                    oncancel={(e) => {
                      setOpenAvatarEditor(false);
                    }}
                  ></AvatarEditor>
                </div>

                {/* 各語系內容編輯 */}
                <Segment>
                  {/* 文章標題 */}
                  <input
                    placeholder="標題"
                    fluid
                    defaultValue={title[editLang.value]}
                    onBlur={() => {
                      var _t = Object.assign({}, title);
                      _t[editLang.value] = titleRef.current.value;
                      setTitle(_t);
                    }}
                    ref={titleRef}
                    //value={title[editLang.value]}
                    className="ca__titleInput"
                    /*                      
                    onChange={(e) => {
                      var _title = Object.assign({}, title);
                      console.log(title);
                      _title[editLang.value] = e.target.value;
                      setTitle(_title);
                    }}*/
                  />

                  {/* 文字編輯 */}
                  <div className="ca__textEditor">
                    <Editor
                      apiKey="achh8lkgat7b66bdkib49hzudaze1pul809bodwrh8m7ayvt"
                      onInit={(evt, editor) => (textRef.current = editor)}
                      onBlur={() => {
                        //紀錄內文
                        var _c = Object.assign({}, text);
                        _c[editLang.value] = textRef.current.getContent();
                        setText(_c);
                      }}
                      initialValue={text[editLang.value]}
                      /*
                      onEditorChange={(e) => {
                        var _c = Object.assign({}, text);
                        //_c[editLang.value].text = e;
                        _c[editLang.value] = e;
                        setText(_c);
                        if (textRef.current)
                          console.log(textRef.current.getContent());
                      }}*/
                      //value={text[editLang.value]}
                      init={{
                        selector: "#editor",
                        skin: "Oxide",
                        media_live_embeds: true,
                        language: window.navigator.language.replace("-", "_"),
                        plugins:
                          "print toc preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap emoticons",
                        imagetools_cors_hosts: ["picsum.photos"],
                        menubar:
                          "file edit view insert format tools table help",
                        toolbar:
                          "toc | undo redo | bold italic table toc underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview print | insertfile image media template link anchor codesample | ltr rtl",
                        toolbar_sticky: true,
                        autosave_ask_before_unload: false,
                        autosave_interval: "30s",
                        autosave_prefix: "{path}{query}-{id}-",
                        autosave_restore_when_empty: false,
                        autosave_retention: "2m",
                        image_advtab: true,
                        link_list: [
                          {
                            title: "My page 1",
                            value: "https://www.tiny.cloud",
                          },
                          {
                            title: "My page 2",
                            value: "http://www.moxiecode.com",
                          },
                        ],
                        image_list: [
                          {
                            title: "My page 1",
                            value: "https://www.tiny.cloud",
                          },
                          {
                            title: "My page 2",
                            value: "http://www.moxiecode.com",
                          },
                        ],
                        image_class_list: [
                          { title: "None", value: "" },
                          { title: "Some class", value: "class-name" },
                        ],
                        importcss_append: true,
                        file_picker_callback: function (callback, value, meta) {
                          /* Provide file and text for the link dialog */
                          if (meta.filetype === "file") {
                            callback(
                              "https://www.google.com/logos/google.jpg",
                              {
                                text: "My text",
                              }
                            );
                          }

                          /* Provide image and alt text for the image dialog */
                          if (meta.filetype === "image") {
                            callback(
                              "https://www.google.com/logos/google.jpg",
                              {
                                alt: "My alt text",
                              }
                            );
                          }

                          /* Provide alternative source and posted for the media dialog */
                          if (meta.filetype === "media") {
                            callback("movie.mp4", {
                              source2: "alt.ogg",
                              poster: "https://www.google.com/logos/google.jpg",
                            });
                          }
                        },
                        templates: [
                          {
                            title: "New Table",
                            description: "creates a new table",
                            content:
                              '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
                          },
                          {
                            title: "Starting my story",
                            description: "A cure for writers block",
                            content: "Once upon a time...",
                          },
                          {
                            title: "New list with dates",
                            description: "New List with dates",
                            content:
                              '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
                          },
                        ],
                        template_cdate_format:
                          "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
                        template_mdate_format:
                          "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
                        height: 600,
                        image_caption: true,
                        quickbars_selection_toolbar:
                          "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
                        noneditable_noneditable_class: "mceNonEditable",
                        toolbar_mode: "sliding",
                        contextmenu: "link image imagetools table",

                        statusbar: false,
                        skin: "naked",
                        //skin: useDarkMode ? "oxide-dark" : "oxide",
                        //content_css: useDarkMode ? "dark" : "default",
                        content_css: "//www.tiny.cloud/css/codepen.min.css",
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                      }}
                    />
                  </div>
                </Segment>
                {/* 輸入tag */}
                <Grid>
                  <Grid.Row className="ui ca__tagsContainer">
                    <Input
                      icon="tags"
                      iconPosition="left"
                      label={{ tag: true, content: "Add Tag" }}
                      labelPosition="right"
                      placeholder="Enter tags"
                      value={tagInput}
                      onChange={(e) => {
                        e.preventDefault();
                        e.target.focus();
                        window.onbeforeunload = null;
                        setTagInput(e.target.value);
                      }}
                      onKeyUp={(e) => handleAddTag(e)}
                    />
                    {/* tag列表 */}
                    <div className="ca__tagsContainer">
                      <Label.Group>
                        {tags?.map((tag, index) => {
                          return (
                            <Label
                              as="a"
                              key={index}
                              onClick={() => {
                                console.log(index);
                                handleDeleteTag(index);
                              }}
                            >
                              {tag}
                            </Label>
                          );
                        })}
                      </Label.Group>
                    </div>
                  </Grid.Row>
                </Grid>
              </form>
            </div>
          </Dimmer.Dimmable>
        </AdminContent>
      </>
    );
}

export default CreateArticle;
